import { SVGProps } from '@components/Icon/types';

export const History = ({ fill = '#000', size = 24, ...props }: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g transform="translate(1.9, 2.55)">
      <path
        d="M10.7248 0C15.9573 0 20.1991 4.24126 20.1994 9.47363C20.1994 14.706 15.958 18.9468 10.7258 18.9473C7.77556 18.9953 4.98754 17.5993 3.25997 15.207C3.028 14.8808 3.10399 14.4275 3.42989 14.1953C3.75607 13.963 4.20926 14.0394 4.44161 14.3652C5.89786 16.3734 8.24287 17.5429 10.7229 17.498H10.7248C14.6602 17.4987 18.0155 14.6452 18.6467 10.7607C19.3572 6.38642 16.3869 2.2645 12.0129 1.55371C7.74576 0.860476 3.71976 3.67006 2.86544 7.86914L3.02364 7.70996C3.30665 7.42702 3.76593 7.42716 4.04903 7.70996C4.33203 7.99304 4.33204 8.45228 4.04903 8.73535L2.48653 10.2969C2.38496 10.3992 2.25664 10.4688 2.11739 10.4971L1.97579 10.5117H1.90255C1.71374 10.4917 1.54106 10.3974 1.4211 10.2529L1.37325 10.1885L0.124227 8.31348C-0.0998296 7.98117 -0.0125504 7.53087 0.31954 7.30664C0.651794 7.08237 1.10299 7.17094 1.32735 7.50293L1.42891 7.6543C2.29566 3.21997 6.18374 0.000154784 10.7248 0ZM10.4123 3.38672C10.8404 3.38674 11.1877 3.73402 11.1877 4.16211V9.39941L14.5998 11.9824H14.5988C14.9412 12.2393 15.0109 12.7249 14.7541 13.0674C14.4972 13.4097 14.0116 13.4785 13.6691 13.2217L9.91915 10.4102L9.91524 10.4062C9.74088 10.2656 9.63705 10.0339 9.63692 9.78711V4.16211C9.63696 3.73412 9.98436 3.38691 10.4123 3.38672Z"
        fill={fill}
      />
    </g>
  </svg>
);

export const ICON_NAME = 'history';
